/** @format */

import React, { useRef } from "react";
import {
  HeroGrid,
  DesktopTextHolder,
  HeroText,
  OuterSpan,
  InnerSpan,
} from "../Common";
import { container, paragraphStyles } from "../../helpers";
import styled from "styled-components";
import { useInView } from "framer-motion";

export default function ProcessHeader({ mouseEnter, mouseLeave }) {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, amount: 0.1 });
  const showAnimation = isInView ? "show" : "initial";

  return (
    <>
      <HeroGrid>
        <DesktopTextHolder
          variants={container}
          initial="hidden"
          animate={showAnimation}
        >
          <LargeText ref={ref}>
            <OuterSpan variants={paragraphStyles}>
              <LargeText>Our</LargeText>
              <LargeText>Data</LargeText>
            </OuterSpan>
            <OuterSpan>
              <LargeText variants={paragraphStyles}>And</LargeText>
            </OuterSpan>
            <OuterSpan>
              <LargeText variants={paragraphStyles}>information</LargeText>
            </OuterSpan>
            <OuterSpan>
              <RedText
                onMouseEnter={mouseEnter}
                onMouseLeave={mouseLeave}
                variants={paragraphStyles}
              >
                Collection
              </RedText>
            </OuterSpan>
            <OuterSpan>
              <LargeText variants={paragraphStyles}>Process</LargeText>
            </OuterSpan>
          </LargeText>
        </DesktopTextHolder>
      </HeroGrid>
    </>
  );
}

const LargeText = styled(HeroText)`
  color: var(--color-offwhite);
  font-size: clamp(2.75rem, 6vw + 1.7rem, 10rem);
  &::after {
    content: "";
    margin-right: 10px;
  }
`;

const RedText = styled(InnerSpan)`
  font-size: clamp(2.75rem, 6vw + 1.7rem, 10rem);
  color: var(--color-primary);
`;
